/* =============================================
   Collection Filter — 2016/ store
   ============================================= */

(function () {
  'use strict';

        // 言語判定（html要素のlang属性を使用）
    const lang = document.documentElement.lang || 'ja';
    const isJa = lang.startsWith('ja');

    const PREFIX = isJa
      ? {
          category: 'カテゴリー：',
          designer: 'デザイナー：',
          size:     'サイズ：'
        }
      : {
          category: 'category:',
          designer: 'designer:',
          size:     'size:'
        };


  function getTagValues(product, prefix) {
    return (product.dataset.tags || '')
      .split(',')
      .map(t => t.trim())
      .filter(t => t.startsWith(prefix))
      .map(t => t.slice(prefix.length));
  }

  function initFilter() {
    const filter = document.querySelector('.c-filter');
    if (!filter) return;

    const selects = {
      category: filter.querySelector('[data-filter="category"]'),
      designer: filter.querySelector('[data-filter="designer"]'),
      size:     filter.querySelector('[data-filter="size"]')
    };
    const resetBtn = filter.querySelector('.c-filter__reset');
    const products = Array.from(
      document.querySelectorAll('.c-products__inr .c-product-li')
    );

    // --- タグから選択肢を動的生成 ---
    const sets = { category: new Set(), designer: new Set(), size: new Set() };

    products.forEach(p => {
      Object.keys(PREFIX).forEach(key => {
        getTagValues(p, PREFIX[key]).forEach(v => sets[key].add(v));
      });
    });

    Object.keys(sets).forEach(key => {
      const sel = selects[key];
      if (!sel) return;
      [...sets[key]].sort().forEach(val => {
        const opt = document.createElement('option');
        opt.value = val;
        opt.textContent = val;
        sel.appendChild(opt);
      });
    });

    // --- フィルタリング処理 ---
    function applyFilter() {
      const active = {
        category: selects.category?.value || '',
        designer: selects.designer?.value || '',
        size:     selects.size?.value     || ''
      };

      const isAnyActive = Object.values(active).some(v => v !== '');
      resetBtn.hidden = !isAnyActive;

      products.forEach(p => {
        const match = Object.keys(active).every(key => {
          if (!active[key]) return true;
          return getTagValues(p, PREFIX[key]).includes(active[key]);
        });
        p.classList.toggle('-hidden', !match);
      });
    }

    Object.values(selects).forEach(sel => {
      if (sel) sel.addEventListener('change', applyFilter);
    });

    resetBtn.addEventListener('click', () => {
      Object.values(selects).forEach(sel => { if (sel) sel.value = ''; });
      applyFilter();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilter);
  } else {
    initFilter();
  }
})();
